import styled from "styled-components";

export const Name = styled.div`
  font-weight: 700;
  font-size: 1.25em;
`;

export const Address = styled.div`
  font-size: 0.875em;
  color: #555555;
`;

export const Contact = styled.div`
  font-weight: 700;
  font-size: 0.875em;
  line-height: 1.2em;
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${({ $padded }) => $padded && `
    padding: 20px;
    margin-bottom: 20px;
  `}

  ${({ $bordered }) => $bordered && `
    border: 1px solid #eee;
    border-top: none;

    & ${Name} {
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 10px;
    }
  `}
`;
